import { useTranslation } from 'react-i18next';
import styled from '@emotion/styled';
import { Icon } from '@hotjar/hotsauce';
import { Action, Container, Content, IconContainer, Text, Title } from './common';

const StyledText = styled(Text)`
  white-space: pre-line;
`;

export const RegexNotSupportedError = (): JSX.Element => {
  const { t } = useTranslation();

  return (
    <Container>
      <Content>
        <IconContainer>
          <Icon icon="warning_alt" size="l" color="text_disabled" />
        </IconContainer>
        <Title>{t('heatmaps:regex-error.title')}</Title>
        <Action>
          <StyledText as="p" textType="caption" color="text_light">
            {t('heatmaps:regex-error.description')}
          </StyledText>
        </Action>
      </Content>
    </Container>
  );
};
